import { render } from "./SetNotification.vue?vue&type=template&id=5bb4a817"
import script from "./SetNotification.vue?vue&type=script&lang=js"
export * from "./SetNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__